var parent = require('../../es/instance/reduce');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/reduce.js
// module id = 6447
// module chunks = 25